import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, vShow as _vShow, withDirectives as _withDirectives, createSlots as _createSlots, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/resettime.png'
import _imports_1 from '@/assets/anquanxunjian/steptip.png'
import _imports_2 from '@/assets/inspection/normal.png'
import _imports_3 from '@/assets/inspection/abnormal.png'


const _withScopeId = n => (_pushScopeId("data-v-642f7540"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "inspection-container" }
const _hoisted_2 = { class: "filterarea" }
const _hoisted_3 = { class: "selecttime" }
const _hoisted_4 = ["src"]
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "开始巡检", -1))
const _hoisted_6 = { class: "first-tab" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "steptip",
  src: _imports_1
}, null, -1))
const _hoisted_8 = { class: "step-top" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = ["src", "onClick"]
const _hoisted_11 = ["src"]
const _hoisted_12 = ["title"]
const _hoisted_13 = {
  key: 0,
  src: _imports_2
}
const _hoisted_14 = {
  key: 1,
  src: _imports_3
}
const _hoisted_15 = { class: "second-tab" }
const _hoisted_16 = ["src", "onClick"]
const _hoisted_17 = ["src"]
const _hoisted_18 = ["title"]
const _hoisted_19 = {
  key: 0,
  src: _imports_2
}
const _hoisted_20 = {
  key: 1,
  src: _imports_3
}
const _hoisted_21 = { style: {"height":"100%","display":"flex","justify-content":"center","align-items":"center"} }
const _hoisted_22 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_nav_bar = _resolveComponent("van-nav-bar")!
  const _component_van_dropdown_item = _resolveComponent("van-dropdown-item")!
  const _component_van_dropdown_menu = _resolveComponent("van-dropdown-menu")!
  const _component_van_datetime_picker = _resolveComponent("van-datetime-picker")!
  const _component_van_popup = _resolveComponent("van-popup")!
  const _component_van_button = _resolveComponent("van-button")!
  const _component_van_swipe_cell = _resolveComponent("van-swipe-cell")!
  const _component_van_step = _resolveComponent("van-step")!
  const _component_van_steps = _resolveComponent("van-steps")!
  const _component_van_list = _resolveComponent("van-list")!
  const _component_van_pull_refresh = _resolveComponent("van-pull-refresh")!
  const _component_van_tab = _resolveComponent("van-tab")!
  const _component_van_tabs = _resolveComponent("van-tabs")!
  const _component_van_overlay = _resolveComponent("van-overlay")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_nav_bar, {
      "left-arrow": "",
      title: _ctx.$route.meta.title,
      placeholder: "",
      onClickLeft: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.go(-1)))
    }, null, 8, ["title"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_van_dropdown_menu, null, {
        default: _withCtx(() => [
          _createVNode(_component_van_dropdown_item, {
            class: "topdropdown",
            modelValue: _ctx.selectType,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectType) = $event)),
            options: _ctx.allQuestions,
            onChange: _ctx.fChangeSearch
          }, null, 8, ["modelValue", "options", "onChange"]),
          _createVNode(_component_van_dropdown_item, {
            class: "topdropdown",
            modelValue: _ctx.selectStatus,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.selectStatus) = $event)),
            options: _ctx.allStatus,
            onChange: _ctx.fChangeSearch
          }, null, 8, ["modelValue", "options", "onChange"])
        ]),
        _: 1
      }),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", {
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showTime = true))
        }, _toDisplayString(_ctx.date ? _ctx.currentDate() : "请选择时间"), 1),
        _createElementVNode("img", {
          src: _imports_0,
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.fSetTime && _ctx.fSetTime(...args)))
        })
      ])
    ]),
    _createVNode(_component_van_popup, {
      show: _ctx.showTime,
      "onUpdate:show": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.showTime) = $event)),
      position: "bottom"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_datetime_picker, {
          value: new Date(),
          "min-date": new Date(2019, 0, 1),
          type: "date",
          onConfirm: _ctx.fConfirmDate,
          onCancel: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showTime = false))
        }, null, 8, ["value", "min-date", "onConfirm"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createElementVNode("div", {
      class: "addbtn",
      onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.fGoAdd && _ctx.fGoAdd(...args)))
    }, [
      _createElementVNode("div", null, [
        _createElementVNode("img", {
          src: require('@/assets/inspection/inspection.png')
        }, null, 8, _hoisted_4),
        _hoisted_5
      ])
    ]),
    _createVNode(_component_van_tabs, {
      active: _ctx.active,
      "onUpdate:active": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.active) = $event)),
      animated: "",
      swipeable: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_van_tab, { title: "巡检点记录" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_van_pull_refresh, {
                modelValue: _ctx.refreshing1,
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.refreshing1) = $event)),
                onRefresh: _ctx.onRefresh1
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_list, {
                    loading: _ctx.loading1,
                    "onUpdate:loading": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.loading1) = $event)),
                    finished: _ctx.finished1,
                    "finished-text": "没有更多了",
                    "loading-text": "正在加载,请稍后..",
                    onLoad: _ctx.onLoad1
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_van_steps, {
                        direction: "vertical",
                        "active-color": "#0A3F70",
                        "inactive-color": "#0A3F70",
                        active: 10
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recordsFirstTab, (li) => {
                            return (_openBlock(), _createBlock(_component_van_step, {
                              key: li.id
                            }, {
                              "inactive-icon": _withCtx(() => [
                                _hoisted_7
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_van_swipe_cell, null, _createSlots({
                                  default: _withCtx(() => [
                                    _createElementVNode("div", _hoisted_8, [
                                      _createElementVNode("div", null, _toDisplayString(li.createDate), 1),
                                      (li.result !== 1 && li.rectifyStatus != null)
                                        ? (_openBlock(), _createElementBlock("div", {
                                            key: 0,
                                            class: _normalizeClass(["step-status", {
                          _no: li.rectifyStatus === 1,
                          _yes: li.rectifyStatus === 2,
                          _resove: li.rectifyStatus === 3,
                          _lou: li.rectifyStatus === 4,
                        }])
                                          }, _toDisplayString(li.rectifyStatus === 1
                            ? "未处理"
                            : li.rectifyStatus === 2
                            ? "已处理"
                            : li.rectifyStatus === 3
                            ? "已解决"
                            : "漏检"), 3))
                                        : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", {
                                      class: "card",
                                      onClick: ($event: any) => (_ctx.fGoDetail(li))
                                    }, [
                                      _createElementVNode("div", null, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(li.fileUrl.split(','), (url) => {
                                          return _withDirectives((_openBlock(), _createElementBlock("img", {
                                            key: url,
                                            src: url,
                                            onClick: ($event: any) => (_ctx.previewimgfun(url))
                                          }, null, 8, _hoisted_10)), [
                                            [_vShow, li.fileUrl !== '']
                                          ])
                                        }), 128)),
                                        _withDirectives(_createElementVNode("img", {
                                          src: require('@/assets/inspection/zhanwei.svg')
                                        }, null, 8, _hoisted_11), [
                                          [_vShow, li.fileUrl === '']
                                        ])
                                      ]),
                                      _createElementVNode("div", null, [
                                        _createElementVNode("div", {
                                          title: li.pointName
                                        }, _toDisplayString(li.pointName), 9, _hoisted_12),
                                        _createElementVNode("div", null, _toDisplayString(li.createName), 1),
                                        _createElementVNode("div", null, "备注：" + _toDisplayString(li.remark === "" ? "无" : li.remark), 1),
                                        _createElementVNode("div", null, _toDisplayString(li.createDate), 1)
                                      ]),
                                      _createElementVNode("div", null, [
                                        (li.status === 1)
                                          ? (_openBlock(), _createElementBlock("img", _hoisted_13))
                                          : (_openBlock(), _createElementBlock("img", _hoisted_14))
                                      ])
                                    ], 8, _hoisted_9)
                                  ]),
                                  _: 2
                                }, [
                                  (_ctx.selectType === 2)
                                    ? {
                                        name: "right",
                                        fn: _withCtx(() => [
                                          _createVNode(_component_van_button, {
                                            square: "",
                                            type: "danger",
                                            text: "删除",
                                            style: {"height":"100%"},
                                            onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.remove(_ctx.item)))
                                          })
                                        ])
                                      }
                                    : undefined
                                ]), 1024)
                              ]),
                              _: 2
                            }, 1024))
                          }), 128))
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["loading", "finished", "onLoad"])
                ]),
                _: 1
              }, 8, ["modelValue", "onRefresh"])
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_van_tab, { title: "巡检路线记录" }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_15, [
              _createVNode(_component_van_pull_refresh, {
                modelValue: _ctx.refreshing2,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.refreshing2) = $event)),
                onRefresh: _ctx.onRefresh2
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_van_list, {
                    loading: _ctx.loading2,
                    "onUpdate:loading": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.loading2) = $event)),
                    finished: _ctx.finished2,
                    "finished-text": "没有更多了",
                    "loading-text": "正在加载,请稍后..",
                    onLoad: _ctx.onLoad2
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.recordsSecondTab, (li, index) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "card",
                          key: index
                        }, [
                          _createElementVNode("div", null, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(li.fileUrl.split(','), (url) => {
                              return _withDirectives((_openBlock(), _createElementBlock("img", {
                                key: url,
                                src: url,
                                onClick: ($event: any) => (_ctx.previewimgfun(url))
                              }, null, 8, _hoisted_16)), [
                                [_vShow, li.fileUrl !== '']
                              ])
                            }), 128)),
                            _withDirectives(_createElementVNode("img", {
                              src: require('@/assets/inspection/zhanwei.svg')
                            }, null, 8, _hoisted_17), [
                              [_vShow, li.fileUrl === '']
                            ])
                          ]),
                          _createElementVNode("div", null, [
                            _createElementVNode("div", {
                              title: li.pointName
                            }, _toDisplayString(li.pointName), 9, _hoisted_18),
                            _createElementVNode("div", null, _toDisplayString(li.createName), 1),
                            _createElementVNode("div", null, "备注：" + _toDisplayString(li.remark === "" ? "无" : li.remark), 1),
                            _createElementVNode("div", null, _toDisplayString(li.createDate), 1)
                          ]),
                          _createElementVNode("div", null, [
                            (li.status === 1)
                              ? (_openBlock(), _createElementBlock("img", _hoisted_19))
                              : (_openBlock(), _createElementBlock("img", _hoisted_20))
                          ]),
                          _createElementVNode("div", null, "巡检路线：" + _toDisplayString(li.wayName), 1)
                        ]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["loading", "finished", "onLoad"])
                ]),
                _: 1
              }, 8, ["modelValue", "onRefresh"])
            ])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["active"]),
    _createVNode(_component_van_overlay, {
      show: _ctx.show,
      onClick: _cache[14] || (_cache[14] = ($event: any) => (_ctx.show = false))
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("img", {
            src: _ctx.previewimg,
            style: {"height":"60%","width":"100%"}
          }, null, 8, _hoisted_22)
        ])
      ]),
      _: 1
    }, 8, ["show"])
  ]))
}